// If you don't want to use TypeScript you can delete this file!
import React from 'react'

import BlockContent from 'src/components/global/BlockContent'

import { Image } from 'src/components/image'
import { SEO } from 'src/components/seo'
import { Serializer } from 'src/utils/serializer'
import { RenderModules } from 'src/utils/renderModules'
import { LocationCard } from 'src/components/locations/locationCard'

import {
  TeamShapeOne,
  TeamShapeTwo,
  TeamShapeThree,
  TeamShapeFour,
  TeamShapeFive,
} from 'src/components/svgs'
import Content from 'src/components/content'
import { generateAuthorProfileSchema } from 'src/components/schema'
import type { AuthorSchemaDetails } from 'src/components/schema'

const ShapeArray = (shape: number) => {
  const className = `abs x z1 y top team__card-shape left`
  switch (shape) {
    case 1:
      return <TeamShapeOne className={className} />
    case 2:
      return <TeamShapeThree className={className} />
    case 3:
      return <TeamShapeFour className={className} />
    case 4:
      return <TeamShapeFive className={className} />
    default:
      return <TeamShapeTwo className={className} />
  }
}

export interface TeamProps {
  pageContext: {
    main: {
      modules: []
      location: any
      facts?: any[]
      locations?: any[]
      title: string
      text?: any
      position?: string
      specialties?: string[]
      isAuthor?: boolean
      authorSchema?: AuthorSchemaDetails
      image: {
        asset: {
          _id: string
          url: string
          metadata?: {
            dimensions?: {
              width?: number
              height?: number
            }
          }
        }
      }
      slug: {
        current: string
      }
    }
    meta: {}
    env: 'production' | 'development' | 'local' | 'staging'
    pagePath?: string
  }
  path: string
}

const Team = ({ path, pageContext }: TeamProps) => {
  const {
    main: {
      modules,
      title,
      location,
      locations,
      text,
      facts,
      image,
      position,
      specialties,
      slug,
      isAuthor,
      authorSchema,
    },
    meta,
    env,
  } = pageContext
  const shape = Math.floor(Math.random() * 3)
  const pagePath = pageContext.pagePath || path
  const schema = isAuthor
    ? generateAuthorProfileSchema({
        pagePath,
        title,
        slug,
        position,
        text,
        specialties,
        image,
        authorSchema,
      })
    : undefined
  return (
    <>
      <SEO
        metaInfo={meta}
        pagePath={pagePath.replace(/^\/+/, '')}
        env={env}
        schema={schema}
      />
      <div className="container--l outer p1 mxa team-profile">
        <div className="team-profile__media ccream rel">
          {ShapeArray(shape)}
          <Image className="x" imageId={image.asset._id} alt={title} />
        </div>
        <div className="team-profile__content rel z1">
          <div className="team-profile__header">
            <h1 className="s30 m0 p0 team-profile__title">{title}</h1>
            {position && (
              <span className="p team-profile__position">{position}</span>
            )}
          </div>
          <div className="team-profile__bio">
            {text && <BlockContent blocks={text} serializers={Serializer} />}
          </div>
        </div>
      </div>
      {facts && facts.length > -1 && (
        <div className="py1 pym container--l outer cb mxa f ais fw">
          {facts?.map((fact, i) => (
            <div key={i} className="col-m-5 x team__fact f jcs ais">
              {fact?.image && fact?.image?.asset ? (
                <Image
                  className="x mr1 col-m-3"
                  imageId={fact.image.asset._id}
                  alt={title}
                />
              ) : null}
              <div className="x col-m-6 ml1 team__fact-text mt20">
                <h5 className="caps mono py0 m0">{fact.title}</h5>
                {fact.text && (
                  <BlockContent blocks={fact.text} serializers={Serializer} />
                )}
              </div>
            </div>
          ))}
        </div>
      )}
      {locations && locations.length > 0 && (
        <div className="container--l outer py1 pbm p1 mxa">
          <h3>Find me at</h3>
          <div className="teamLocations">
            {locations?.map(location => (
              <LocationCard {...location} />
            ))}
          </div>
        </div>
      )}
      <Content modules={modules}></Content>
    </>
  )
}

export default Team
